import React from 'react';
import Information from '../components/complexComponents/Information';
import Showcase from '../components/complexComponents/Showcase';
import ShowcaseNavBar from '../components/complexComponents/ShowcaseNavBar';
import blue from '../assets/img/blue.jpg';
import { useProgressiveImage } from '../utils/hooks';
import ImportantInfo from '../components/basicComponents/ImportantInfo';
import { getText } from '../utils/functions';

function Home({
	portal,
	colors,
	translate,
	routing,
	setRouting,
}) {
	/* Sections variables */
	const [desktopSections, setDesktopSections] = React.useState();

	// Lazy loading images so they dont blink
	const lazyLoadImage = useProgressiveImage(portal?.config?.home?.bgImage);

	// Desktop sections dont include home
	const getDesktopSections = React.useCallback(() => {
		const deskSections = portal?.config?.sections ?
			Object.values(portal?.config?.sections)
				.filter(section => section.isActive && section.value !== 'home')
			: [];
		if (!portal?.config?.sections?.documents.isActive
			|| portal?.attachments?.length <= 3) {
			return deskSections.filter(section => section.value !== 'documents');
		}
		return deskSections;
	}, [portal?.config?.sections]);

	React.useEffect(() => {
		setDesktopSections(getDesktopSections());
	}, [getDesktopSections]);

	return <section className='relative'>
		{/* NAVIGATION */}
		<ShowcaseNavBar
			sections={desktopSections}
			bgImg={lazyLoadImage ?? blue}
			routing={routing}
			setRouting={setRouting}
			colors={colors}
			translate={translate} />
		{/* HOME CONTENT */}
		<Showcase
			data={portal?.config?.home}
			portal={portal}
			bgImg={lazyLoadImage ?? blue}
			colors={colors}
			translate={translate}
			setRouting={setRouting} />
		{/* Important INFO */}
		{portal?.config?.home?.highlighted.isActive && getText(portal?.config?.home?.highlighted, translate)
		&& <ImportantInfo
			colors={colors}
			translate={translate}
			portal={portal}
		/>}
		<Information
			portal={portal}
			data={portal?.config?.home}
			documents={portal?.attachments?.slice(0, 3)}
			labels={portal?.config?.labels}
			colors={colors}
			translate={translate}
			setRouting={setRouting} />
	</section>;
}

export default Home;
